/**
 * Created by Julio Perez on 4/10/2017.
 */

export default function routes($stateProvider){

    $stateProvider
        .state('appView.mapSection', {
            url: '/mapPage',
            views:{
                "map-section@appView":{
                    template: require('./index.html')
                }
            }

        })

}

routes.$inject = ['$stateProvider'];


// WEBPACK FOOTER //
// ./src/app/views/map-page/map-page.routes.js